import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <Link to="/" className="inline-block mb-6">
                <span className="inline-flex items-center bg-white rounded-lg border-2 border-accent-500 px-2.5 py-1">
                  <img
                    src="/images/logo.webp"
                    alt="Askari Security Services logo"
                    className="h-14 md:h-16 w-auto"
                  />
                </span>
              </Link>
              <p className="text-background-50/60 text-sm leading-relaxed mb-6">
                California&apos;s trusted private security firm. Protecting people, property, and peace of mind since 2013.
              </p>
              <div className="text-background-50/40 text-xs">
                <p>CA PPO #17831</p>
                <p>Licensed &middot; Bonded &middot; Insured</p>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading text-sm font-bold tracking-wider uppercase text-background-50/80 mb-6">
                Quick Links
              </h4>
              <ul className="space-y-3">
                {[
                  { label: "Home", href: "/" },
                  { label: "About", href: "/about" },
                  { label: "Services", href: "/services" },
                  { label: "Testimonials", href: "/testimonials" },
                  { label: "Contact", href: "/contact" },
                ].map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-background-50/60 hover:text-accent-400 text-sm transition-colors duration-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-heading text-sm font-bold tracking-wider uppercase text-background-50/80 mb-6">
                Services
              </h4>
              <ul className="space-y-3">
                {[
                  "Unarmed Security",
                  "Executive Protection",
                  "Event Security",
                  "Vehicle Patrol",
                  "Fire Watch",
                  "Loss Prevention",
                ].map((service) => (
                  <li key={service}>
                    <Link
                      to="/services"
                      className="text-background-50/60 hover:text-accent-400 text-sm transition-colors duration-300"
                    >
                      {service}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-heading text-sm font-bold tracking-wider uppercase text-background-50/80 mb-6">
                Contact
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="tel:+15626060053"
                    className="text-background-50/60 hover:text-accent-400 text-sm transition-colors duration-300 flex items-center gap-2"
                  >
                    <i className="ri-phone-line text-accent-400" />
                    (562) 606-0053
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:office@askari.org"
                    className="text-background-50/60 hover:text-accent-400 text-sm transition-colors duration-300 flex items-center gap-2"
                  >
                    <i className="ri-mail-line text-accent-400" />
                    office@askari.org
                  </a>
                </li>
                <li className="text-background-50/60 text-sm flex items-start gap-2">
                  <i className="ri-map-pin-line text-accent-400 mt-0.5" />
                  <span>
                    5150 Candlewood Street, Suite 16H
                    <br />
                    Lakewood, CA 90712
                  </span>
                </li>
              </ul>

              <div className="mt-6 flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-accent-500 rounded-lg transition-colors duration-300"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-background-50" />
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-accent-500 rounded-lg transition-colors duration-300"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-background-50" />
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-accent-500 rounded-lg transition-colors duration-300"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-background-50" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-50/10">
        <div className="px-4 md:px-6 lg:px-10 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-50/40 text-xs text-center sm:text-left">
              &copy; 2025 Askari Security Services. All Rights Reserved.
            </p>
            <div className="flex items-center gap-6 text-background-50/40 text-xs">
              <a href="#" className="hover:text-background-50/60 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-background-50/60 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="hover:text-background-50/60 transition-colors">
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}